import React, { useEffect, useState } from "react";
import BreadCrumb from "@/components/Listing/BreadCrumb";
import BlogCategories from "@/components/blog/BlogCategories";
import SearchBar from "@/components/blog/SearchBar";
import BlogCard from "@/components/blog/BlogCard";
import SocialMediaSection from "@/components/blog/SocialMediaSection";
import RecentPosts from "@/components/blog/RecentPosts";
import VillaRentalAreas from "@/components/blog/VillaRentalAreas";
import BlogPagination from "@/components/blog/BlogPagination";
import { useRouter } from "next/router";

const Blog = ({ data, dataHeader }) => {
  const router = useRouter();

  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    router.push(`/blog-kesfet?page=${pageNumber}`);
  };

  useEffect(() => {
    const page = parseInt(router.query.page) || 1;
    setCurrentPage(page);
  }, [router.query.page]);

  return (
    <div className="py-6">
      <div className="container">
        <div className="mb-5 lg:mb-10 md:mb-7">
          <BreadCrumb data={data} />
        </div>
        <div className="border-b-4 border-[#F0ECF4] flex lg:items-center items-start gap-4 lg:flex-row flex-col justify-between pb-6 mb-3">
          <BlogCategories categories={data?.BlogData?.Categories} />
          <SearchBar />
        </div>
        <div className="grid grid-cols-12 md:gap-x-8">
          <div className="col-span-12 mb-5 lg:col-span-9 lg:mb-0">
            <div
              className={`${
                data?.BlogData?.result > 0 ? "border-b-4 border-[#F0ECF4]" : ""
              } grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3 pb-5 mb-2`}
            >
              {data?.BlogData?.result?.map((blog) => (
                <BlogCard key={blog.id} blog={blog} />
              ))}
            </div>
            <BlogPagination
              data={data?.BlogData}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
          <div className="col-span-12 lg:col-span-3">
            <SocialMediaSection dataHeader={dataHeader} />
            <RecentPosts posts={data?.BlogData?.LastShared} />
            <VillaRentalAreas />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
